$(function () {
  addIsRequired()
})
function addIsRequired() {
  $(".kentico-form form div [aria-required='true']")
    .parents('.form-field')
    .find('label')
    .not('.ktc-radio label')
    .addClass('is-required')
}
$('#mainContent .kentico-form').bind('DOMSubtreeModified', function () {
  addIsRequired()
})
$('.kentico-form').on('click', '#form-btn', function () {
  var currentFormWrapper = $(this).parents('.kentico-form')
  highlightEmpty()
})
function highlightEmpty() {
  $('.kentico-form')
    .find('input[aria-required=true]')
    .each(function () {
      if ($(this).attr('type') == 'text' || $(this).attr('type') == 'email') {
        ToggleRedBorder($(this))
      }
    })
  $('.kentico-form')
    .find('select[aria-required=true]')
    .each(function () {
      ToggleRedBorder($(this))
    })
  $('.kentico-form')
    .find('textarea[aria-required=true]')
    .each(function () {
      ToggleRedBorder($(this))
    })
  $('.kentico-form')
    .find('.cb-required')
    .each(function () {
      var filled = false
      $(this)
        .find('input[type=radio]:checked')
        .each(function () {
          filled = true
        })
      if (!filled) {
        $(this).addClass('input-validation-error')
      } else {
        $(this).removeClass('input-validation-error')
      }
    })
}

function ToggleRedBorder(ele) {
  if ($(ele).val()) {
    $(ele).removeClass('input-validation-error')
  } else {
    $(ele).addClass('input-validation-error')
  }
}
